import React from 'react';


export default function WhitePage(props) {
    return (<></>);
}